import { Skeleton, Card, Col, Row } from "antd";
import { FC } from "react";


interface SkeletonCardProps {
  count: number;
  loading: boolean;
  children: any;
  customGutter: any;
  rowCount?: number;
}

const SkeletonCard: FC<SkeletonCardProps> = ({
  count = 1,
  loading = false,
  children,
  customGutter,
  rowCount = 1,
}) => {
  if (!loading) return children;

  const totalCards = count * rowCount;
  const columnsPerRow = Math.round(24 / count);

  return (
    <>
      {[...Array(rowCount)].map((_, rowIndex) => (
        <Row gutter={customGutter} key={rowIndex}>
          {[...Array(count)].map((_, colIndex) => {
            const keyIndex = rowIndex * count + colIndex;
            return (
              <Col xs={12} sm={12} lg={6}   key={keyIndex}>
                <Card className="rounded-bl-md rounded-br-md mb-4">
                <div className="!bg-[#f0f0f0] !w-full !h-[200px] !flex justify-center items-center ">
                        <div className="!w-[70px] !h-[70px] !rounded-full !bg-[#FFEDCC] !flex items-center justify-center" >

                          <div className="!w-[40px] !h-[40px] loader" ></div>
                        </div>
                     
                      </div>

                  <div className="!grid gap-1 border-black !pt-2">
                    <div className="!flex items-center justify-between">
                      <Skeleton.Button style={{ width: 120, height: 24 }} active />
                      <Skeleton.Button style={{ width: 80, height: 16 }} active />
                    </div>
                    <Skeleton.Input style={{ width: "80%" }} active />
                    <Skeleton.Input style={{ width: "60%" }} active />
                    <div className="!flex items-center gap-6">
                      <Skeleton.Avatar size={50} active />
                      <div>
                        <Skeleton.Input style={{ width: 100, height: 20 }} active />
                        <Skeleton.Input style={{ width: 80, height: 16 }} active />
                      </div>
                    </div>
                  </div>
                </Card>
              </Col>
            );
          })}
        </Row>
      ))}
    </>
  );
};

export default SkeletonCard;
